import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { FollowUp } from './FollowUp';
import { FollowUpQA } from './FollowUpQA';
import { Admin } from '../Admin';
import { Utils } from '../Utils';

@supertypeClass({ toClient: true })
export class FollowUpComment extends Everything {
  @property({ getType: () => FollowUp })
  followUp: FollowUp;

  @property({ getType: () => FollowUpQA })
  followUpQA: FollowUpQA;

  @property()
  creator: Admin;

  @property()
  content: string;

  @property()
  createdDate: Date;

  constructor() {
    super();
  }

  static new(linkedEntity, content, creator) {
    return new FollowUpComment().init(linkedEntity, content, creator);
  }

  init(linkedEntity, content, creator) {
    if (linkedEntity instanceof FollowUp) {
      this.followUp = linkedEntity;
    } else if (linkedEntity instanceof FollowUpQA) {
      this.followUp = linkedEntity.followUp;
      this.followUpQA = linkedEntity;
    }

    this.content = content;
    this.creator = creator;
    this.createdDate = Utils.now();
    return this;
  }
}
